var map = {
	"./de/btn-download-xbox.png": "X9ED",
	"./en/btn-download-xbox.png": "8POG",
	"./es/btn-download-xbox.png": "mB97",
	"./fr/btn-download-xbox.png": "QYsL",
	"./ja/btn-download-xbox.png": "s3hP",
	"./ko/btn-download-xbox.png": "FELE",
	"./pt/btn-download-xbox.png": "4oE4",
	"./ru/btn-download-xbox.png": "+t6q",
	"./tc/btn-download-xbox.png": "+Ajl",
	"./th/btn-download-xbox.png": "6650",
	"./zh-Hant/btn-download-xbox.png": "g9rU"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "fhTi";